import { FormattedMessage } from "react-intl";
import styles from "./PrintStatusTag.module.scss";
import { PrintStatus } from "common/api/decimal/methods/course";
import clsx from "clsx";
import MiscellaneousCheckmarkCircle from "common/icons/MiscellaneousCheckmarkCircle.tsx";
import MiscellaneousWarning from "common/icons/MiscellaneousWarning.tsx";
import OffScreen from "common/core-ui/OffScreen";
import { ReactNode } from "react";

const PrintStatusTagWrapper = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => (
  <div>
    <div
      data-testid="print-status-tag"
      className={clsx("vst-mini-tag", className)}
    >
      {children}
    </div>
  </div>
);

const MoreInfo = () => (
  <OffScreen>
    <FormattedMessage
      defaultMessage={"See 'View Details' for more information"}
    />
  </OffScreen>
);

export default function PrintStatusTag({
  printStatus,
}: {
  printStatus?: PrintStatus;
}) {
  if (printStatus === "Not Issued") {
    return (
      <PrintStatusTagWrapper className={styles.ready}>
        <MiscellaneousCheckmarkCircle className={styles.icon} />
        <FormattedMessage defaultMessage={"Ready to Pick Up"} />
        <MoreInfo />
      </PrintStatusTagWrapper>
    );
  } else if (printStatus === "Not Returned") {
    return (
      <PrintStatusTagWrapper className={styles.warning}>
        <MiscellaneousWarning className={styles.icon} />
        <FormattedMessage defaultMessage={"Needs to be Returned"} />
        <MoreInfo />
      </PrintStatusTagWrapper>
    );
  } else {
    return null;
  }
}
